import React, { Component } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { getBrand } from "../brand/brand-selectors";

class AppSecondaryBackground extends Component {
  static propTypes = {
    brand: PropTypes.object
  };

  getBackgroundStyle(brand) {
    return { backgroundColor: brand.secondaryBackground.backgroundColor };
  }

  render() {
    const { brand, children } = this.props;
    const backgroundStyle = this.getBackgroundStyle(brand);

    return (
      <div className="AppSecondaryBackground">
        <div
          className="AppSecondaryBackground__Background Background"
          style={backgroundStyle}
        />
        <div className="AppSecondaryBackground__Content">{children}</div>
      </div>
    );
  }
}

const mapState = state => ({
  brand: getBrand(state)
});

export default connect(mapState)(AppSecondaryBackground);



// WEBPACK FOOTER //
// ./src/modules/root/app-secondary-background.js